import { Observable } from "rxjs"
import { AccountTypeID } from "../../config/Constants"
import { ObservableFromFetch } from "../ObservableFromFetch"
import AutoFilterCompany from "./CompanyModel/AutoFilterCompany"

export default function AutoFilterCompaniesGetObservable(filter: string, IsFilters: boolean = false): Observable<AutoFilterCompany[]> {
  const requestBody: string = JSON.stringify({
    AccountType: AccountTypeID,
    AutoFilterValue: filter,
    IncludeCompany: true,
    IncludeLocation: false,
    IncludeMaster: false,
    IncludeParent: true,
    IncludeRegion: false,
    IsFilters: IsFilters
  })

  return ObservableFromFetch<AutoFilterCompany[]>("Order/GetAutoFilterCompany", requestBody)
}
